import { z } from "zod/v4";

import { JsonSchema } from "../../../../utils";

export const RechargeWebhookRequestPathParamsSchema = z.object({
  topic: z.string(),
});

export type RechargeWebhookRequestPathParamsType = z.infer<
  typeof RechargeWebhookRequestPathParamsSchema
>;

export const RechargeWebhookRequestBodySchema = z.object({
  order: JsonSchema.nullish(),
  subscription: JsonSchema.nullish(),
});

export type RechargeWebhookRequestBodyType = z.infer<
  typeof RechargeWebhookRequestBodySchema
>;
